// extracted by mini-css-extract-plugin
export default {"menuWrapper":"components-Shared-Form-InputSelect-menuWrapper__menuWrapper--WyBUY"};